<template>
    <div class="download-nametag-container">
        <div class="step-label completed">Begin Identity Verification</div>
        <div class="step-label active">Download Nametag App</div>

        <div class="d-flex justify-content-start flex-column w-100 mb-3">
            <h1 class="header mb-2">Download Nametag App</h1>
            <p class="sub-header mb-0">Autodesk uses Nametag to verify your identity. Download it from
                your app store if you don’t already have it.
            </p>
        </div>

        <div v-if="isRestrictedRegion || verifiedIn24hrs || !isNewHire || isRetryExceeded" class="identity-failure-container"><img
                class="error-image" src="../assets/images/error_icon.png" alt="Error Image" />
            <p class="identity-validation mb-0 text-mobile-center">{{ errorMessage }}
            </p>
        </div>

        <div class="image-container w-100 text-start d-flex flex-row justify-content-start flex-nowrap">
            <div class="qr-code-wrapper text-start d-flex flex-row align-items-center justify-content-start flex-wrap">
                <a href="https://apps.apple.com/zw/app/nametag-sign-in-with-id/id1546248921" target="_blank"><img
                        class="app_store_image" src="../assets/images/app_store.png" alt="Apple Store Image" /></a>
                <img class="desktop-view" src="../assets/images/qr_code_apple_app_store.png"
                    alt="Download Nametag Iphone" />
            </div>
            <div></div>
            <div
                class="qr-code-wrapper google-store-wrapper border-none border-lg-1 text-start d-flex flex-row align-items-center justify-content-start flex-wrap ml-0 ml-lg-4 pl-0 pl-lg-4">
                <a href="https://play.google.com/store/apps/details?id=nametag.hello" target="_blank"><img
                        class="app_store_image" src="../assets/images/google_playstore.png"
                        alt="Goggle Play Store Image" /></a>
                <img class="desktop-view" src="../assets/images/qr_code_google_play_store.png"
                    alt="Download Nametag Android" />
            </div>
        </div>

        <div class="d-flex justify-content-end w-100 button-container error-message-container">
            <div class="button-container">
                <button class="button cancel-button ml-3 cursor-pointer" @click="cancelStep">Cancel</button>
                <button v-if="isRestrictedRegion || isRetryExceeded" class="button next-button ml-3 cursor-pointer"
                 @click="showManualVerification">Next</button>
                <button v-else class="button next-button ml-3 cursor-pointer" :disabled="verifiedIn24hrs || !isNewHire"
                    @click="nextStep">Next</button>
            </div>
        </div>

        <div class="mobile-stepper">
            <IdentityVerificationMobileStepper :currentStep="1" />
        </div>
        <loading-overlay v-if="isLoading"></loading-overlay>
    </div>
</template>

<script>
import LoadingOverlay from '@/components/LoadingOverlay.vue';
import IdentityVerificationMobileStepper from '@/components/IdentityVerificationMobileStepper.vue';
import CONSTANTS from "@/constants";
export default {
    name: "DownloadNametagApp",
    components: {
        LoadingOverlay,
        IdentityVerificationMobileStepper
    },
    props: {
        isRestrictedRegion: {
            type: Boolean,
            required: true
        },
        isNewHire: {
            type: Boolean,
            required: true
        },
        verifiedIn24hrs: {
            type: Boolean,
            required: true
        },
        isRetryExceeded: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            isLoading: false,
            errorMessage: ''
        }
    },
    mounted() {
        this.validateUserRegion();
    },
    methods: {
        showManualVerification() {
            this.$emit("showManualVerification");
        },
        cancelStep() {
            document.title = 'Enterprise Search';
            this.$router.push('/');
        },
        validateUserRegion() {
            if (this.isRetryExceeded) {
                this.errorMessage = CONSTANTS.ERROR_MESSAGES.Retry_Limit_Exceeded;
            }
            else if (this.isRestrictedRegion) {
                this.errorMessage = CONSTANTS.ERROR_MESSAGES.isRestrictedRegion;
            } else if (!this.isNewHire) {
                this.errorMessage = CONSTANTS.ERROR_MESSAGES.isNewHire;
            } else if (this.verifiedIn24hrs) {
                this.errorMessage = CONSTANTS.ERROR_MESSAGES.verifiedIn24hrs;
            }
        },
        nextStep() {
            this.isLoading = true;
            setTimeout(() => {
                this.$emit("nextStep", 2);
                this.isLoading = false;
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            }, 3000)
        }
    }
};
</script>

<style scoped>
.download-nametag-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    height: auto;
    max-width: 1200px;
    color: black;
    font-family: artifaktElementRegular;
    padding: 0px 10px;
    margin-top: 20px;
}

.header {
    font-size: 18px;
    font-weight: 700;
    color: black;
    font-family: artifaktElementBold;
    margin: 20px 0px;
}

.identity-failure-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin-top: 20px;
}

.error-image {
    width: 40px;
    margin-right: 20px;
}

.identity-validation {
    font-size: 18px;
    font-weight: 700;
    text-align: center;
}

.sub-header {
    font-size: 15px;
}

.checkbox-container {
    margin: 10px 0px;
}

.google-store-wrapper {
    margin-left: 150px !important;
}

.custom-checkbox {
    width: 18px;
    height: 17px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 3px;
    position: relative;
    margin-right: 8px;
    cursor: pointer;
    margin-top: 4px;
}

.desktop-view {
    display: flex !important;
}

.custom-checkbox:checked::before {
    content: '\2714';
    font-size: smaller;
    position: absolute;
    top: 50%;
    left: 50%;
    width: 17px;
    height: 17px;
    background-color: #5f60ff;
    border-radius: 2px;
    transform: translate(-50%, -50%);
    text-align: center;
    color: white;
}

.checkbox-label {
    font-size: 14px;
    width: 90%;
}

.link {
    color: #5f60ff;
    text-decoration: none;
    word-break: break-all;
}

.link:hover {
    text-decoration: underline;
}

.mobile-stepper {
    display: none;
}

.step-label {
    display: none;
    margin-top: 3px;
    margin-bottom: 20px;
}

.image-container {
    margin-top: 40px;
    margin-bottom: 20px;
}

.image-container img {
    width: 150px;
    height: 150px;
    margin-right: 20px;
    margin-top: 20px;
}

.app_store_image {
    width: 130px !important;
    height: 40px !important;
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.button-container {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 20px !important;
}

.button {
    padding: 6px 40px;
    border-radius: 40px;
    font-weight: 700;
    font-size: 14px;
    width: 130px;
    height: 36px;
}

.cancel-button {
    background-color: white;
    color: #5f60ff;
    border: 2px solid #5f60ff;
}

.qr-code-wrapper {
    margin-left: 50px;
}

.next-button {
    background-color: #5f60ff;
    color: white;
    border: none;
}

.next-button:hover:not(:disabled) {
    background-color: #5a52d1;
}

.next-button:disabled {
    background-color: #ccc;
    cursor: not-allowed;
}

.error-message {
    color: red;
    font-size: 14px;
}

@media ((min-width: 700px) and (max-width: 900px)) {
    .qr-code-wrapper {
        flex-direction: column !important;
    }

    .google-store-wrapper {
        margin-left: 30px !important;
        padding-left: 50px !important;
    }
}

@media (max-width: 700px) {
    .download-nametag-container {
        border-left: 2px solid lightgray;
        padding-left: 20px;
        margin-left: 14px;
        margin-top: -90px;
    }

    .header {
        display: none;
    }

    .sub-header {
        margin-top: 10px;
    }

    .identity-failure-container {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .error-image {
        width: 40px;
        margin: 0px;
    }

    .custom-label {
        margin-left: 40px;
        margin-bottom: 100px;
        margin-top: -56px;
    }

    .custom-checkbox {
        width: 20px;
    }

    .button-container {
        padding-right: 0px !important;
        width: 100%;
        align-items: center;
        justify-content: center;
    }

    .image-container {
        margin-top: 0px;
        margin-bottom: 0px;
        justify-content: flex-start !important;
        flex-wrap: wrap !important;
    }

    .google-store-wrapper {
        border: 0px;
        padding-left: 0px !important;
        margin-left: 10px !important;
    }

    .error-message-container {
        flex-direction: column;
    }

    .cancel-button {
        margin-left: 0px !important;
    }

    .qr-code-wrapper {
        margin-top: 15px;
        margin-left: 10px;
    }

    .app_store_image {
        width: 180px !important;
        height: 54px !important;
        margin-bottom: 16px !important;
    }

    .image-container img {
        width: 100%;
        margin: 0px;
        max-width: 200px;
    }

    .mobile-stepper {
        display: block;
    }

    .error-message {
        margin-top: 0px !important;
    }

    .step-label {
        display: flex;
        font-weight: normal;
        white-space: nowrap;
        width: auto;
        font-size: 16px;
        color: gray;
        font-weight: 700;
        margin-bottom: 0px !important;
        margin-left: 4px !important;
    }

    .step-label.active {
        font-weight: bold;
        color: black;
    }

    .desktop-view {
        display: none !important;
        margin-top: 20px !important;
        margin-left: 20px !important;
    }

    .step-label.completed {
        font-weight: 100;
        color: black;
        margin-bottom: 32px !important;
    }
}
</style>